// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"330":"55310cb3","533":"e70c58df"}[chunkId] + ".css";
};